import {z} from 'zod';

export const GenerateBodySchema = z.object({
  prompt: z.string(),
  theme: z.string(),
  themeId: z.number(),
  hashtagIds: z.array(z.number()),
});

export const GenerateResponseSchema = z.object({
  entrysheetBuilderId: z.string(),
  generatedText: z.string(),
});

const ThemeSchema = z.object({
  id: z.number(),
  name: z.string(),
  displayOrder: z.number(),
});

export const ThemesResponseSchema = z.object({
  themes: z.array(ThemeSchema),
});

const QuestionChoiceSchema = z.object({
  id: z.number(),
  choice: z.string(),
});

const QuestionSchema = z.object({
  id: z.number(),
  question: z.string(),
  questionType: z.string(),
  options: z.array(QuestionChoiceSchema),
});

export const QuestionsResponseSchema = z.object({
  questions: z.array(QuestionSchema),
});

export const GetResultResponseScema = z.object({
  entrysheetBuilderId: z.string(),
  entrysheetThemeId: z.number(),
  result: z.string(),
});
